
import physiqueManage from './physiqueManage'

export default {
  physiqueManage,
}